import { RootState } from 'app/configureStore';
import { DO_APPLICATION_TYPE } from 'client-experience-toolbox';
import { useSelector } from 'react-redux';

export const useApplication = (type: DO_APPLICATION_TYPE) => {
  const factoringSection = useSelector((state: RootState) => state.applicationReducer.factoringSection);
  const factoringApplication = useSelector((state: RootState) => state.applicationReducer.factoringApplication);
  const bankingSection = useSelector((state: RootState) => state.applicationReducer.bankingSection);
  const bankingApplication = useSelector((state: RootState) => state.applicationReducer.bankingApplication);
  switch (type) {
    case DO_APPLICATION_TYPE.FACTORING:
      return {
        section: factoringSection,
        application: factoringApplication,
        totalSections: 5,
      };
    case DO_APPLICATION_TYPE.BANKING:
      return {
        section: bankingSection,
        application: bankingApplication,
        totalSections: 10,
      };
    default:
      throw new Error(`Unsupported application type: ${type}`);
  }
};
